import React, { useMemo } from 'react';
import { TouchableWithoutFeedback } from 'react-native';
import Animated, {
  Extrapolation,
  interpolate,
  useAnimatedStyle,
} from 'react-native-reanimated';
import { BottomSheetBackdropProps } from './BottomSheetModal.types';

export function createCustomBackdrop(
  onClose?: () => void,
): React.FC<BottomSheetBackdropProps> {
  const CustomBackdrop = ({
    isFullyOpened,
    closeOnBlur,
    animatedIndex,
    style,
  }: BottomSheetBackdropProps) => {
    const opacity = useAnimatedStyle(() => ({
      opacity: interpolate(
        animatedIndex.value,
        [-1, 0],
        [0, 0.5],
        Extrapolation.CLAMP,
      ),
    }));

    const containerStyle = useMemo(
      () => [style, { backgroundColor: '#000' }, opacity],
      [style, opacity],
    );

    return (
      <TouchableWithoutFeedback
        onPress={onClose}
        disabled={!closeOnBlur || !isFullyOpened}
        accessibilityLabel="Close bottom drawer"
        accessibilityHint=""
        onAccessibilityEscape={() => {
          onClose?.();
        }}
      >
        <Animated.View style={containerStyle} pointerEvents="auto" />
      </TouchableWithoutFeedback>
    );
  };
  return CustomBackdrop;
}
